import type { PaymentColumnId } from "../types/payments.types";

export const PAYMENTS_API_ENDPOINTS = {
  PAYMENTS: "/internal/operations/payments",
  paymentById: (id: string) => `/internal/operations/payments/${id}`,
  status: (id: string) => `/internal/operations/payments/${id}/status`,
  pay: (id: string) => `/internal/operations/payments/${id}/pay`,
  take: (id: string) => `/internal/operations/payments/${id}/take`,
  release: (id: string) => `/internal/operations/payments/${id}/release`,
  forceRelease: (id: string) => `/internal/operations/payments/${id}/force-release`,
  history: (id: string) => `/internal/operations/payments/${id}/history`,
  attachmentPresignedUrl: (id: string) => `/internal/operations/payments/${id}/attachment-presigned-url`,
  takerReminder: (id: string) =>
    `/internal/operations/notifications/reminders/payments/${encodeURIComponent(id)}`,
  pendingTotals: "/internal/operations/payments/totals/pending",
} as const;

export const PAYMENT_COLUMNS: { id: PaymentColumnId; label: string }[] = [
  { id: "pending", label: "Pendiente" },
  { id: "in_progress", label: "En proceso" },
  { id: "paid", label: "Pagado" },
];

export const COLUMN_PENDING: PaymentColumnId = "pending";
export const COLUMN_IN_PROGRESS: PaymentColumnId = "in_progress";
export const COLUMN_PAID: PaymentColumnId = "paid";

export const PAYMENTS_PAGE_SIZE = 25;
